import { render, staticRenderFns } from "./q-pop-card-bug.vue?vue&type=template&id=5ef228b8&scoped=true&"
import script from "./q-pop-card-bug.vue?vue&type=script&lang=js&"
export * from "./q-pop-card-bug.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-card-bug.vue?vue&type=style&index=0&id=5ef228b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef228b8",
  null
  
)

export default component.exports